import React from 'react';
import Card from '../shared/Card';
const About = () => {
  return (
    <section id="about" className="py-16 px-4">
      <div className="max-w-6xl mx-auto">
       <div className="mb-12">
          <p className="text-center text-gray-600 max-w-3xl mx-auto text-lg leading-relaxed">
            The Adelaide Samba Encontro is South Australia's premier Samba event, 
            bringing together dancers, musicians, and enthusiasts for a weekend of 
            learning, performance, and celebration. Join us in April 2025 for an 
            unforgettable experience of Brazilian culture and dance.
          </p>
        </div>

        {/* Event Details */}
        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <Card>
            <h3 className="text-2xl font-bold text-primary-purple mb-4">
              Event History
            </h3>
            <p className="text-gray-600 mb-4">
              The streets of Adelaide saw the first flight of the Cacatuas back in 2018
              since then we have had the pleasure of hosting the largest bateria seen to date in AU and NZ 
              in 2019 and were much overdue to have the cacatuas flight on the sky of Adelaide
              once more.
            </p>
            <p className="text-gray-600">
              Our 2025 edition promises to be our biggest yet, featuring a long weekend of workshops,
              community Samba drumming and dancing, partying and the best gift we can hand over to 
              the Adelaide community, a daylight performance on the Sunday in the legendary and always
              welcoming to locals and visitors, Moseley Square in Glenelg Beach. Brace yourselves because
              it will be EPIC!
            </p>
          </Card>
          <Card>
            <h3 className="text-2xl font-bold text-primary-purple mb-4">
              What to Expect
            </h3>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-start">
                <span className="text-primary-orange mr-2">•</span>
                An afternoon filled with drumming and dancing workshops brought to you by AU and NZ mestres de bateria and experienced dancing instructors
              </li>
              <li className="flex items-start">
                <span className="text-primary-orange mr-2">•</span>
                People from all over AU and NZ 
              </li>
              <li className="flex items-start">
                <span className="text-primary-orange mr-2">•</span>
                A Samba showcase with local, national and international baterias
              </li>
              <li className="flex items-start">
                <span className="text-primary-orange mr-2">•</span>
                Networking opportunities with the Samba community
              </li>
            </ul>
          </Card>
           
           </div>  
        </div>
        {/* Welcome Pack CTA Card - Full Width */}
        <div className="mt-12 bg-white rounded-xl shadow-md p-6">
          <h3 className="text-xl font-bold text-[#2E0854]">New to Adelaide?</h3>
          <p className="mt-1">Check out our welcome pack with tips for getting around, local attractions, and event venues.</p>
          <a 
            href="/assets/documents/ASE25WelcomePack.pdf" 
            download="ASE25WelcomePack.pdf"
            className="inline-flex items-center mt-4 px-6 py-2 bg-gradient-to-r from-[#FFE135] to-[#FF4500] text-white font-medium rounded-full hover:shadow-lg transition-all duration-300"
          >
            Download
          </a>
      </div>
    </section>
  );
};

export default About;